/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainRecruiterNewDriverStatus } from '../../entities/domain/RecruiterNewDriverStatus'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainRecruiterNewDriverStatusSchema = z.enum([
  'new',
  'notified',
  'confirmed',
  'declined',
  'canceled',
  'error',
]) as unknown as ToZod<DomainRecruiterNewDriverStatus>